import { FAQS } from "@/lib/constants";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section bg-cream-deep"
    >
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <span className="eyebrow">questions, kindly answered</span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
            Common{" "}
            <span className="font-script text-[hsl(var(--sage-deep))]">
              questions
            </span>
            .
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-10 space-y-4"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="recipe-card !rounded-2xl border-0 px-2 sm:px-4"
            >
              <AccordionTrigger className="px-3 py-5 text-left font-serif-display text-lg sm:text-xl text-[hsl(var(--brown))] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-3 pb-5 text-sm sm:text-base leading-relaxed text-[hsl(var(--brown-soft))]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
